import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Button, Typography } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedFilters } from '../../../../actions/visits/visits.actions'

import { DeletableChip } from '../../../Misc/DeletableChip'
import { cloneDeep } from 'lodash'

const useStyles = makeStyles((theme) => ({
	wrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap'
	}
}))

export const SelectedFilters = (props) => {
	const classes = useStyles()

	const { filters, selectedFilters, setFilters } = props

	return (
		<div className={classes.wrapper}>
			<div className={classes.wrapper}>
				{selectedFilters.map((i) => (
					<DeletableChip
						key={i.value}
						label={i.label}
						style={{
							marginBottom: 2
						}}
						{...{
							onDelete: () => {
								let updates = selectedFilters.filter((f) => f.value !== i.value)

								setFilters(updates)
							}
						}}
					/>
				))}
			</div>

			<Button
				variant="text"
				style={{
					borderRadius: 6,
					marginBottom: 2
				}}
				onClick={() => {
					setFilters([])
				}}>
				<Typography variant="overline" style={{ color: '#6B4AD6', lineHeight: 1 }}>
					Clear Filters
				</Typography>
			</Button>
		</div>
	)
}
